<template>
  <div class="index">
    <div class="title">正在建设中....</div>
    <div class="footer">
      <div class="mid">备案号:桂ICP备2024033312号</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Index",
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style scoped lang="less">
@import "./index.less";
</style>
